export default function Subscribe() {
    const SHOP_LINK = "https://chatmate.gumroad.com/l/chatmateai_extra";
    if(typeof(window) !== "undefined") {
        window.location.href = SHOP_LINK;
    }
    return <a href={SHOP_LINK}><div>Redirecting to shop...</div></a>
}